import { IModel, Model, ModelRecord } from '@common/models';
import { StringUtility } from '@common/utils';
import { DateTime } from 'luxon';

export interface IVisitAnesthesiaFormPostSurgeryVitalModel extends IModel {
  visitAnesthesiaFormPostSurgeryVitalId: number;
  visitAnesthesiaFormPostSurgeryId: number;
  temperature: string;
  hr: string;
  rr: string;
  painScore: string;
  interval: number;
  dateCreated: string | undefined;
  dateUpdated: string | undefined;
}

export class VisitAnesthesiaFormPostSurgeryVitalModel
  extends Model
  implements ModelRecord<IVisitAnesthesiaFormPostSurgeryVitalModel>
{
  visitAnesthesiaFormPostSurgeryVitalId: number;
  visitAnesthesiaFormPostSurgeryId: number;
  temperature: string;
  hr: string;
  rr: string;
  painScore: string;
  interval: number;
  dateCreated: DateTime | undefined;
  dateUpdated: DateTime | undefined;

  constructor(params?: Partial<IVisitAnesthesiaFormPostSurgeryVitalModel>) {
    super(params);
    this.visitAnesthesiaFormPostSurgeryVitalId = _.defaultTo(
      params?.visitAnesthesiaFormPostSurgeryVitalId,
      0,
    );
    this.visitAnesthesiaFormPostSurgeryId = _.defaultTo(
      params?.visitAnesthesiaFormPostSurgeryId,
      0,
    );
    this.temperature = _.defaultTo(params?.temperature, '');
    this.hr = _.defaultTo(params?.hr, '');
    this.rr = _.defaultTo(params?.rr, '');
    this.painScore = _.defaultTo(params?.painScore, '');
    this.interval = _.defaultTo(params?.interval, 0);
    this.dateCreated = StringUtility.SanitizeDateTimeISOAsUtc(
      params?.dateCreated,
    );
    this.dateUpdated = StringUtility.SanitizeDateTimeISOAsUtc(
      params?.dateUpdated,
    );
  }
}
